import type { FC } from "react";
import type { TabProps } from "../../Tabs.props";

const Tab: FC<TabProps> = () => {
  throw new Error("Tab used outside of a tabs context.");
};

export default Tab;
